import Legend from './legend.js';
export default Legend;
